import { ButtonGroup, IconButton, Box } from '@mui/material'
import { CleanThemeProvider } from 'shared/theme/cleanThemeProvider'

export type ViewMode = 'large' | 'small'

interface ViewToggleButtonProps {
  value: ViewMode
  onChange: (value: ViewMode) => void
}

function ViewToggleButtonContent ({ value, onChange }: ViewToggleButtonProps) {
  const handleLargeClick = () => {
    if (value !== 'large') {
      onChange('large')
    }
  }

  const handleSmallClick = () => {
    if (value !== 'small') {
      onChange('small')
    }
  }

  return (
    <ButtonGroup
      sx={{
        height: 32
      }}
    >
      <IconButton
        aria-label="Large card view"
        onClick={handleLargeClick}
        sx={{
          px: '12px',
          py: '8px',
          height: 32,
          borderRadius: '4px 0 0 4px',
          border: '1px solid rgba(0, 0, 0, 0.2)',
          bgcolor: 'transparent',
          '&:hover': {
            bgcolor: 'rgba(0, 0, 0, 0.04)'
          }
        }}
      >
        <Box
          alt="Large card view"
          component="img"
          src="/assets/icons/view-toggle/grid-icon.svg"
          sx={{
            width: 20,
            height: 20,
            filter: value === 'large'
              ? 'invert(39%) sepia(93%) saturate(3477%) hue-rotate(222deg) brightness(101%) contrast(106%)'
              : 'invert(47%) sepia(0%) saturate(0%) hue-rotate(212deg) brightness(92%) contrast(88%)'
          }}
        />
      </IconButton>
      <IconButton
        aria-label="Small card view"
        onClick={handleSmallClick}
        sx={{
          px: '12px',
          py: '8px',
          height: 32,
          borderRadius: '0 4px 4px 0',
          border: '1px solid rgba(0, 0, 0, 0.2)',
          borderLeft: 'none',
          bgcolor: 'transparent',
          '&:hover': {
            bgcolor: 'rgba(0, 0, 0, 0.04)'
          }
        }}
      >
        <Box
          alt="Small card view"
          component="img"
          src="/assets/icons/view-toggle/list-icon.svg"
          sx={{
            width: 20,
            height: 20,
            filter: value === 'small'
              ? 'invert(39%) sepia(93%) saturate(3477%) hue-rotate(222deg) brightness(101%) contrast(106%)'
              : 'invert(47%) sepia(0%) saturate(0%) hue-rotate(212deg) brightness(92%) contrast(88%)'
          }}
        />
      </IconButton>
    </ButtonGroup>
  )
}

export default function ViewToggleButton (props: ViewToggleButtonProps) {
  return (
    <CleanThemeProvider>
      <ViewToggleButtonContent {...props} />
    </CleanThemeProvider>
  )
}
